import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { moment, type Nil } from '@pbt/pbt-ui-components'

import { fetchAttachmentHistory } from '~/store/actions/medicalHistory'
import {
  getAttachmentHistory,
  getMedicalHistory,
  getMedicalHistoryIsFetching,
} from '~/store/reducers/medicalHistory'
import { sortDateDesc } from '~/utils/time'

const MAX_ATTACHMENT_AGE_DAYS = 60

const useAttachmentHistory = (patientId?: string | Nil) => {
  const dispatch = useDispatch()
  const attachments = useSelector(getAttachmentHistory)
  const isFetching = useSelector(getMedicalHistoryIsFetching)
  const { error } = useSelector(getMedicalHistory)

  const sortedAttachments = useMemo(
    () =>
      // Sort attachments by date descending (newest first)
      [...attachments].sort((a, b) => sortDateDesc(a.date, b.date)),
    [attachments],
  )

  useEffect(() => {
    if (patientId) {
      const to = moment().toISOString()
      const from = moment()
        .subtract(MAX_ATTACHMENT_AGE_DAYS, 'days')
        .toISOString()

      dispatch(fetchAttachmentHistory(patientId, from, to))
    }
  }, [dispatch, patientId])

  return {
    attachments: sortedAttachments,
    error,
    isFetching,
  }
}

export default useAttachmentHistory
